import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as ActionsList from './actions';
import { map, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { UnderlyingInvestmentService } from 'src/app/services/underlying-investment.service';
import { EmploymentService } from '../../../services/employment.service';

@Injectable()
export class CurrentEmployerEffects {
  constructor(private store: Store<any>,
    private actions$: Actions,
    private router: Router,
    private service: EmploymentService ) {
  }

  getData$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsList.RequestAction),
    switchMap((action: any) => this.service.getCurrentEmployment(action.accountId)),
    map((data: any) => {
      return ActionsList.ResponseAction({ payload: data.data });
    })
  ));
  
}
